//src/hooks/useAi.ts
import { useQuery } from "@tanstack/react-query";

import { listAiHistory } from "@/services/ai";

export function useAiHistory(params: {
  page?: number;
  per_page?: number;
  feature?: string;
  transaction_type?: string;
  start_date?: string;
  end_date?: string;
}) {
  return useQuery({
    queryKey: ["ai_history", params],
    queryFn: () => listAiHistory(params),
    staleTime: 15_000,
  });
}
